import React from 'react';
import {
  Box,
  Button,
  Card,
  Divider,
  Modal,
  Snackbar,
  Typography,
} from '@mui/material';

const TagsModal = ({ open, onClose, tags, onCopyTag, copiedTag, snackbarOpen, onSnackbarClose }) => {
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Card
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80vw',
            boxShadow: 24,
            p: 4,
            maxHeight: '70vh',
            overflow: 'auto',
          }}
        >
          <Typography variant="h6" mb={2}>
            Теги:
          </Typography>
          {tags.map((tag) =>
            tag.tag !== '{DoctorReviewLink}' && tag.tag !== '{PointsToAddOrWithDraw}' ? (
              <Box key={tag.name} sx={{ my: 1, fontSize: 12 }}>
                <Divider sx={{ mb: 1 }} />
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => onCopyTag(tag.tag)}
                  sx={{ minWidth: 30, mr: 1 }}
                >
                  📋
                </Button>
                <Box
                  component="span"
                  sx={{
                    backgroundColor: '#a9a9a9',
                    borderRadius: '5px',
                    px: 1,
                    py: '2px',
                    userSelect: 'all',
                  }}
                >
                  {tag.tag}
                </Box>{' '}
                - {tag.name}
              </Box>
            ) : null
          )}
        </Card>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        message={`Тег "${copiedTag}" скопирован!`}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={onSnackbarClose}
      />
    </>
  );
};

export default TagsModal;
